var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q12.625 8.5 12 8.5t-1.062.438Q10.5 9.375 10.5 10t.438 1.062q.437.438 1.062.438Zm0 8.75q3.125-2.725 4.812-5.45 1.688-2.725 1.688-4.6 0-2.95-1.887-4.825Q14.725 3.5 12 3.5q-2.725 0-4.612 1.875Q5.5 7.25 5.5 10.2q0 1.875 1.688 4.6Q8.875 17.525 12 20.25Zm0 1.375q-3.8-3.375-5.65-6.25Q4.5 12.5 4.5 10.2q0-3.525 2.263-5.612Q9.025 2.5 12 2.5t5.238 2.088Q19.5 6.675 19.5 10.2q0 2.3-1.85 5.175T12 21.625ZM12 10.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e15d373ae089b9cb7b17d28afacf1222.svg";
export { ForwardRef as ReactComponent };